import React, { useState, useEffect } from "react";
import { TiMinus, TiPlus } from "react-icons/ti";
import { getUserCredentials } from "../../../api/usuarioApi";
import { getAdminById } from "../../../api/AdminApi";
import AlquileresActivos from "./AlquileresActivos";
import AlquileresByDate from "./AlquileresByDate";
import AlquilerItems from "./items";

export default function Alquileres() {
  // 🔹 Secciones plegables
  const [showActivos, setShowActivos] = useState(true);
  const [showByDate, setShowByDate] = useState(false);
  const [showItems, setShowItems] = useState(false);

  // 🔹 Permisos
  const [loading, setLoading] = useState(true);
  const [hasPermission, setHasPermission] = useState(undefined);
  // viewOnly = true cuando sesiones=true pero cierres=false
  const [viewOnly, setViewOnly] = useState(false);

  // 🔹 Trigger de recarga de ítems
  const [refreshItems, setRefreshItems] = useState(false);

  const handleRefreshItems = () => {
    setRefreshItems((prev) => !prev);
  };

  // 🔹 Verifica permisos de usuario
  useEffect(() => {
    const checkPermission = async () => {
      setLoading(true);
      try {
        const resultUser = await getUserCredentials();
        const USERDATA = await getAdminById(resultUser.IdUsuario);
        const admin = USERDATA?.[0];

        const tieneCierres = admin?.cierres === "true";
        const tieneSesiones = admin?.sesiones === "true";

        if (!admin) {
          setHasPermission(false);
          return;
        }

        if (tieneCierres) {
          // ✅ Acceso completo
          setHasPermission(true);
          setViewOnly(false);
        } else if (tieneSesiones) {
          // 👁️ Solo lectura (sin monto)
          setHasPermission(true);
          setViewOnly(true);
        } else {
          // 🚫 Sin acceso
          setHasPermission(false);
        }
      } catch (e) {
        console.error("Error al verificar permisos:", e);
        setHasPermission(false);
      } finally {
        setLoading(false);
      }
    };
    checkPermission();
  }, []);

  // 🔹 Spinner de carga
  if (loading) {
    return (
      <div
        style={{
          minHeight: "60vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: 38,
            height: 38,
            border: "4px solid #ddd",
            borderTop: "4px solid #1569c9ff",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />
        <span style={{ marginLeft: 14, color: "#444", fontSize: 18 }}>
          Cargando...
        </span>
        <style>{`
          @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
        `}</style>
      </div>
    );
  }

  // 🔹 Sin permisos
  if (hasPermission === false) {
    return (
      <div style={{ textAlign: "center", marginTop: 50 }}>
        <h3>No tiene permisos para ver esta información.</h3>
      </div>
    );
  }

  if (hasPermission !== true) return null;

  // ✅ Render principal
  return (
    <div className="card">
      <div className="card-header">
        <h4 className="card-title">Gestión de Alquileres</h4>
      </div>

      <div className="card-body">
        {/* ========================================================= */}
        {/* 🔹 SECCIÓN 1: ALQUILERES ACTIVOS */}
        {/* ========================================================= */}
        <div className="col-12 mt-2">
          <h4 className="card-title mb-0 d-flex align-items-center justify-content-between">
            <span>Alquileres Activos</span>
            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={() => setShowActivos(!showActivos)}
              style={{ border: "none", background: "none", boxShadow: "none" }}
              aria-expanded={showActivos}
              aria-label={showActivos ? "Ocultar activos" : "Mostrar activos"}
            >
              {showActivos ? <TiMinus size={24} /> : <TiPlus size={24} />}
            </button>
          </h4>
        </div>
        {showActivos && (
          <AlquileresActivos
            onRefreshItems={handleRefreshItems}
            viewOnly={viewOnly}
          />
        )}

        {/* ========================================================= */}
        {/* 🔹 SECCIÓN 3: ÍTEMS DE ALQUILER */}
        {/* ========================================================= */}
        <div className="col-12 mt-4">
          <h4 className="card-title mb-0 d-flex align-items-center justify-content-between">
            <span>Ítems de Alquiler</span>
            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={() => setShowItems(!showItems)}
              style={{ border: "none", background: "none", boxShadow: "none" }}
              aria-expanded={showItems}
              aria-label={
                showItems
                  ? "Ocultar listado de ítems"
                  : "Mostrar listado de ítems"
              }
            >
              {showItems ? <TiMinus size={24} /> : <TiPlus size={24} />}
            </button>
          </h4>
        </div>
        {showItems && (
          <AlquilerItems
            refreshTrigger={refreshItems}
            viewOnly={viewOnly}
          />
        )}

        {/* ========================================================= */}
        {/* 🔹 SECCIÓN 2: ALQUILERES POR FECHA */}
        {/* ========================================================= */}
        <div className="col-12 mt-4">
          <h4 className="card-title mb-0 d-flex align-items-center justify-content-between">
            <span>Alquileres</span>
            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={() => setShowByDate(!showByDate)}
              style={{ border: "none", background: "none", boxShadow: "none" }}
              aria-expanded={showByDate}
              aria-label={
                showByDate
                  ? "Ocultar alquileres por fecha"
                  : "Mostrar alquileres por fecha"
              }
            >
              {showByDate ? <TiMinus size={24} /> : <TiPlus size={24} />}
            </button>
          </h4>
        </div>
        {showByDate && (
          <AlquileresByDate
            onRefreshItems={handleRefreshItems}
            viewOnly={viewOnly}
          />
        )}
      </div>
    </div>
  );
}
